import { createContext } from 'react'

import { createMemberDeptUserStore } from '../store/createStore'

export const MemberDeptUserStoreContext = createContext<
  ReturnType<typeof createMemberDeptUserStore> | undefined
>(undefined)
